module.exports = __webpack_public_path__ + "img/cooperate_jr_07@2x.1c65396c.png";